<template>
  <div class="user-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :initialSearchFilter="initialSearchFilter"
                          :reload="reload"
                          @searchFilter="getSearchFilter"
                          @showDetail="showDetail">
    </template-search-list>
    <template-detail :infoApi="infoApi"
                       :apiParam="apiParam"
                       :menu="'review'"
                       @button="button"
                       @reload="reloadList">
      </template-detail>

  </div>
</template>

<script>

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateDetail from '@/components/_template/Detail'

import Excel from '@/utils/excel-export'
import { EventBus } from '@/utils/event-bus'
import { STORAGE_ITEM } from '@/utils/constants'
import { getReviewList, getReviewInfo } from '../../../../api/review'

export default {
  name: 'ReviewList',
  components: {
    TemplateSearchList,
    TemplateDetail,
  },
  created () {
    const localStorageData = localStorage.getItem(STORAGE_ITEM.searchData)
    if (localStorageData !== '{}' || localStorageData !== 'null') {
      const searchData = JSON.parse(localStorageData)
      if (searchData && searchData.subject) {
        if (searchData.subject) {
          this.initialSearchFilter.subject = searchData.subject
        }
      }
    }
    localStorage.setItem(STORAGE_ITEM.searchData, null)
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data.id }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    toggleChange (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.change = !this.show.change
      } else {
        this.show.change = value
      }
    },
    toggleExcel (value = false) {
      this.excelDownload = value
    },
    excelExport (col, data, selectCol) {
      const fileName = 'eagle_user'
      const excel = new Excel()
      EventBus.$emit('onLoading', true)
      excel.setExcelData('user', col, data || [], selectCol, {})
        .then(result => {
          excel.download(fileName)
          this.excelDownload = false
          EventBus.$emit('onLoading', false)
        }).catch(e => {
          EventBus.$emit('onLoading', false)
        })
    },
    getSearchFilter (value) {
      this.searchFilter = value
    },
    button (value, data) {
      const nameMap = {
        userForum: 'User',
        postReplyForum: 'PostReply'
      }

      const param = {}

      if (value === 'userForum') {
        param.userId = data
      }

      localStorage.setItem(STORAGE_ITEM.searchData, JSON.stringify(param))
      const route = this.$router.resolve({ name: nameMap[value], params: this.apiParam })
      window.open(route.href, '_blank')
    }
  },
  data () {
    return {
      reload: 0,

      infoApi: getReviewInfo,
      apiParam: null,

      listApi: getReviewList,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '상세 보기',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-regDate',

      show: {
        insert: false,
        change: false
      },
      excelDownload: false,
      initialSearchFilter: {
        key: 'FAQ'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-list-wrap {
}
</style>
